/**
 * 随身打路由
 * */
export default [
  {
    path: '/printIndex',
    name: 'printIndex',
    meta: {
      title: '首页'
    },
    component: () => import('@/views/printerSystem/index')
  },
  {
    path: '/printerClassify',
    name: 'printerClassify',
    meta: {
      title: '主题分类'
    },
    component: () => import('@/views/printerSystem/setting/PrinterClassify'),
  },
  {
    path: '/materialList',
    name: 'materialList',
    meta: {
      title: '素材管理'
    },
    component: () => import('@/views/printerSystem/setting/MaterialList'),
  },
  {
    path: '/feedbackTypeList',
    name: 'feedbackTypeList',
    meta: {
      title: '反馈管理'
    },
    component: () => import('@/views/printerSystem/setting/FeedbackTypeList'),
  },
  {
    path: '/videoList',
    name: 'videoList',
    meta: {
      title: '教程视频'
    },
    component: () => import('@/views/printerSystem/setting/VideoList'),
  },{
    path: '/languageView',
    name: 'languageView',
    meta: {
      title: '语言类型'
    },
    component: () => import('@/views/printerSystem/setting/languageView')
  },{
    path: '/addMaterial',
    name: 'addMaterial',
    meta: {
      title: '新增素材'
    },
    component: () => import('@/views/printerSystem/setting/addMaterial')
  },{
    path: '/printerDeviceList',
    name: 'printerDeviceList',
    meta: {
      title: '设备中心'
    },
    component: () => import('@/views/printerSystem/deviceManage/deviceList')
  },
  {
    path: '/printerMachineList',
    name: 'printerMachineList',
    component: () => import('@/views/printerSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },
  {
    path: '/printerCheckModel',
    name: 'printerCheckModel',
    component: () => import('@/views/printerSystem/deviceManage/checkModel'),
    meta: {
      title: '查看机型'
    }
  },
  {
    path: '/printerAddModelPage',
    name: 'printerAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/printerSystem/deviceManage/addModelPage.vue')
  },
  {
    path: '/printerEditModelPage',
    name: 'printerEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/printerSystem/deviceManage/editModelPage')
  },
  {
    path: '/printerVirtualSnBatchList',
    name: 'printerVirtualSnBatchList',
    component: () => import("@/views/printerSystem/deviceManage/virtualSnBatchList"),
    meta: {
      title: '授权许可'
    }
  },
  {
    path: '/printUserMonthRegister',
    name: 'printUserMonthRegister',
    component: () => import("@/views/printerSystem/bi/userMonthRegister"),
    meta: {
      title: '用户统计'
    }
  },
  {
    path: '/printDeviceMonthRegister',
    name: 'printDeviceMonthRegister',
    component: () => import("@/views/printerSystem/bi/deviceMonthRegister"),
    meta: {
      title: '设备统计'
    }
  },
  {
    path: '/printerChannelList',
    name: 'printerChannelList',
    component:() => import("@/views/printerSystem/deviceManage/channelList"),
    meta: {
      title: '渠道管理'
    }
  },
  {
    path: '/printerChannelAppPage',
    name: 'printerChannelAppPage',
    component:() => import("@/views/printerSystem/deviceManage/ChannelAppPage"),
    meta: {
      title: '关联App'
    }
  },
  {
    path: '/printerDeviceAuthLogonList',
    name: 'printerDeviceAuthLogonList',
    component:() => import("@/views/printerSystem/deviceManage/deviceAuthList"),
    meta: {
      title: '删除授权'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/printerRouter.js